export enum Gender {
   male = "male",
   female = "female",
   other = "other",
}

export const GenderNames = {
   male: "männlich",
   female: "weiblich",
   other: "divers",
 };